import { render, staticRenderFns } from "./TracleerFooter.vue?vue&type=template&id=37bb4db2&scoped=true&"
import script from "./TracleerFooter.vue?vue&type=script&lang=ts&"
export * from "./TracleerFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TracleerFooter.vue?vue&type=style&index=0&id=37bb4db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb4db2",
  null
  
)

export default component.exports